import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import toast, {Toaster} from "react-hot-toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import iconDelete from "../img/icons/icon-trash.svg";
import MD5 from "crypto-js/md5";

export default function ProposalResultReportCreate(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);
    let [sendDate, setSendDate] = React.useState(null);
    let [btnDisabled, setBtnDisabled] = React.useState(false);
    let [statusList, setStatusList] = React.useState(null);

    let [fileList, setFileList] = React.useState([{
        title: null,
        file: null,
        base64: null
    }]);
    let [currentFileIndex, setCurrentFileIndex] = React.useState(null);
    let refFile = React.useRef();

    let refPeriodNo = React.useRef();
    let refPercent = React.useRef();
    let refSummary = React.useRef();
    let refProblem = React.useRef();
    let refRecommend = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resultStatus = await Utils.getResultStatus();
                setStatusList(resultStatus);

                const resDetail = await getDetail();
                if(resDetail) {
                    setDetail(resDetail);

                    if (prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                    }

                    document.title = 'ข้อเสนอโครงการ | NCSA -' + resDetail.title;
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    React.useEffect(() => {
        // --
    }, [fileList]);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onSubmit = async () => {
        let periodNo = refPeriodNo.current.value;
        let percent = refPercent.current.value;
        let summary = refSummary.current.value;
        let problem = refProblem.current.value;
        let recommend = refRecommend.current.value;

        if(periodNo === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Period No':'กรุณาระบุ งวดงาน');
            refPeriodNo.current.focus();
        }
        else if(!sendDate) {
            toast.error(prop.lang === 'en' ? 'Please specify Send Date':'กรุณาระบุ วันที่ส่งรายงาน');
        }
        else if(percent === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Percentage of operational progress':'กรุณาระบุ ร้อยละความก้าวหน้าของการดำเนินงาน');
            refPercent.current.focus();
        }
        else if(summary === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Summary of operating results':'กรุณาระบุ สรุปผลการดำเนินงาน');
            refSummary.current.focus();
        }
        else if(problem === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Problems and Obstacles':'กรุณาระบุ ปัญหาและอุปสรรค');
            refProblem.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ยืนยันการส่งรายงานผลลัพธ์นี้ ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setBtnDisabled(true);

                            let fullname = detail.applicant.prefix + ' ' + detail.applicant.firstname + ' ' + detail.applicant.lastname;
                            let status = detail.status === Utils.PROPOSAL_STATUS_EDIT ? Utils.PROPOSAL_STATUS_UPDATE : Utils.PROPOSAL_STATUS_OFFER;
                            let status_name = statusList.filter(e => e.id === status)[0].title;
                            let datetime = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');

                            let param = {
                                proposalId: detail.id,
                                periodNo: periodNo,
                                sendDate: sendDate,
                                percent: percent,
                                summary: summary,
                                problem: problem,
                                recommend: recommend,
                                files: fileList,
                                status: status,
                                createdBy: -1,
                                createdAt: datetime
                            };
                            const result = await sendReport(param);
                            if (result) {
                                setBtnDisabled(false);
                                toast.success(prop.lang === 'en' ? 'Send Offer successfully.' : 'แจ้งส่งรายงานผลลัพธ์ เรียบร้อย');
                                setTimeout(function () {
                                    toast(prop.lang === 'en' ? 'Sending email, please wait..' : 'กำลังส่งอีเมล กรุณารอสักครู่..');
                                }, 1000);
                                if (result.status === 'success') {
                                    setBtnDisabled(true);
                                    const sendMember = await sendEmail({
                                        email: detail.applicant.email,
                                        proposal_name: detail.title,
                                        proposal_code: detail.code,
                                        scholarship_name: detail.scholarship.title,
                                        send_date: datetime,
                                        status_name: status_name,
                                        sender_name: fullname,
                                        period_no: periodNo
                                    });
                                    const sendAdmin = await sendEmailAdmin({
                                        emails: result.email_admin,
                                        proposal_name: detail.title,
                                        proposal_code: detail.code,
                                        scholarship_name: detail.scholarship.title,
                                        send_date: datetime,
                                        status_name: status_name,
                                        sender_name: fullname,
                                        period_no: periodNo
                                    });

                                    if(sendMember.status === 1 && sendAdmin.status === 1) {
                                        setBtnDisabled(false);
                                        toast.success(prop.lang === 'en' ? 'Send Offer successfully.': 'ส่งอีเมลแจ้งรายงานผลลัพธ์ เรียบร้อย');
                                        setTimeout(function () {
                                            window.location = (prop.lang === 'en' ? '/en/':'') + '/proposalResult/report/' + Utils.encodeItem({proposalId: detail?.id});
                                        }, 1500);
                                    }
                                    else {
                                        toast.error(prop.lang === 'en' ? 'Sorry, Unable to send email at this time':'ขออภัย ไม่สามารถส่งอีเมลได้ในขณะนี้');
                                        setTimeout(function () {
                                            window.location = (prop.lang === 'en' ? '/en/':'') + '/proposalResult/report/' + Utils.encodeItem({proposalId: detail?.id});
                                        }, 1500);
                                    }
                                } else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator' : 'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            } else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.' : 'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {
                        }
                    }
                ]
            });
        }
    };

    async function sendReport(param) {
        const response = await fetch(Config.apiUrl +'/proposalResult/sendReport', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmailAdmin(param) {
        const response = await fetch(Config.phpUrl +'/email_report_admin.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmail(param) {
        const response = await fetch(Config.phpUrl +'/email_report_member.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onChangeDate = async (value) => {
        setSendDate(value);
    };

    //Add file
    const handleClickFile = React.useCallback(() => refFile.current?.click(), []);
    const addNewFile = () => {
        setFileList([...fileList, {
            title: null,
            file: null,
            base64: null
        }]);
    };
    const removeFile = (index) => {
        let wl = [...fileList];
        wl.splice(index, 1);
        setFileList(wl);
    };
    const updateFileTitle = (item, index) => {
        let wl = [...fileList];
        wl[index].title = item;
        setFileList(wl);
    };
    const onSelectFile = (e, data) => {
        if(data) {
            let file_name = e.target.files[0].name;
            let ext = file_name.split('.').pop();
            let file = MD5(moment().format("YMMDDHHmmss") + '_' + currentFileIndex).toString() + '.' + ext;

            let wl = [...fileList];
            wl[currentFileIndex].title = file_name.replace('.' + ext, '');
            wl[currentFileIndex].file = file;
            wl[currentFileIndex].base64 = data;
            setFileList(wl);
        }
    };
    //end

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="result" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 mb-3">{prop.lang === 'en' ? 'Report Results (Add New)':'รายงานผลลัพธ์ (เพิ่มรายงาน)'}</h2>
                                <h4 className="title-line-left mb-3">{(prop.lang === 'en' ? 'Project : ':'โครงการ : ') + detail?.title}</h4>
                                <div className="row g-3 mt-2">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Period No':'งวดงานที่'} <span className="star">*</span></h6>
                                            <input type="number" className="form-control" ref={refPeriodNo} maxLength={11} min={1} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Send Date':'วันที่ส่งรายงาน'} <span className="star">*</span></h6>
                                            <DatePicker
                                                showTimeSelect
                                                selected={sendDate}
                                                onChange={(date) => onChangeDate(date)}
                                                dateFormat="yyyy-MM-dd HH:ii"
                                                wrapperClassName="w-100"
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Percentage of operational progress':'ร้อยละความก้าวหน้าของการดำเนินงาน'} <span className="star">*</span></h6>
                                            <div className="input-group">
                                                <input type="number" className="form-control" ref={refPercent} maxLength={11} />
                                                <div className="input-group-text">%</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Summary of operating results':'สรุปผลการดำเนินงาน'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refSummary} maxLength={3000} rows={5}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Problems and Obstacles':'ปัญหาและอุปสรรค'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refProblem} maxLength={3000} rows={5}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Further advice and information':'คำแนะนำและข้อมูลเพิ่มเติมอื่นๆ'}</h6>
                                            <textarea className="form-control" ref={refRecommend} maxLength={3000} rows={5}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex justify-content-between gap-3">
                                            <h6 className="pt-1">{prop.lang === 'en' ? 'Attachments File':'ไฟล์เอกสารแนบ'}</h6>
                                            <button className="btn btn-xs btn-light-2" onClick={addNewFile}>
                                                {prop.lang === 'en' ? '+ Add File':'+ เพิ่มไฟล์'}
                                            </button>
                                        </div>
                                        <div className="table-responsive mt-3">
                                            <table className="table table-info table-hover text-center">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start">{prop.lang === 'en' ? 'Document Name':'ชื่อเอกสาร'}</th>
                                                        <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</th>
                                                        <th className="text-center" style={{width:'100px'}}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    fileList.length > 0 ?
                                                        fileList.map((row, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <input type="text" className="form-control" onChange={e => updateFileTitle(e.target.value, index)} value={row.title ?? ''}  />
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" className="input-group-text btn btn-sm btn-light" onClick={() => {
                                                                            handleClickFile();
                                                                            setCurrentFileIndex(index);
                                                                        }}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            index > 0 ? <button className="btn btn-trans mx-auto" onClick={() => removeFile(index)}><img className="icons svg-js trash" src={iconDelete} alt="" /></button> : ''
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : ''
                                                }
                                                </tbody>
                                            </table>

                                            <input type="file" className="form-control d-none" ref={refFile} onChange={(e) => {
                                                Utils.onSelectFile(e).then(
                                                    data => onSelectFile(e, data)
                                                );
                                            }} accept={Utils.allowFileExtension} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="buttons gap-15 py-0 mt-5">
                                <NavLink className="btn btn-gray w-130" to={(prop.lang === 'en' ? '/en/':'') + '/proposalResult/report/' + Utils.encodeItem({proposalId: detail?.id})}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</NavLink>
                                <button className="btn btn-secondary w-130" type="button" onClick={onSubmit} disabled={btnDisabled}>{prop.lang === 'en' ? 'Save':'บันทึกข้อมูล'}</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 